import classnames from "classnames";
import { CSSProperties, useId } from "react";
import styles from "./Panel.module.css";

export interface ExtendedPadding {
  top: number;
  right: number;
  bottom: number;
  left: number;
}
export interface PanelProps {
  children: React.ReactNode;
  className?: string;
  padding?: ExtendedPadding;
  style?: CSSProperties;
  title?: string;
}
export default function Panel({
  children,
  className,
  padding,
  style,
  title,
}: Readonly<PanelProps>) {
  const titleId = useId();
  let paddingDefinition = "24px";
  if (padding !== undefined) {
    paddingDefinition = `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px `;
  }
  return (
    <div className={styles.wrapper}>
      {title && (
        <div id={titleId} className={styles.title}>
          {title}
        </div>
      )}
      <div
        aria-labelledby={title ? titleId : undefined}
        className={classnames(styles.container, className)}
        style={{ ...style, padding: paddingDefinition }}
      >
        {children}
      </div>
    </div>
  );
}
